export { default as en } from './en.json';
export { default as es } from './es.json';
export { default as pt } from './pt.json';

export const NS = 'shared-ui' as const;
